// extracted by mini-css-extract-plugin
module.exports = {"txlclqw":"txlclqw","t1a0329c":"t1a0329c"};